import { sdk } from '@wix/image-kit';
const WIX_PROTOCOL = 'wix:';
const WIX_IMAGE = 'image';
const WIX_VIDEO = 'video';
const WIX_AUDIO = 'audio';
const WIX_DOCUMENT = 'document';
const WIX_IMAGE_URL = 'https://static.wixstatic.com/media/';
const WIX_VIDEO_URL = 'https://video.wixstatic.com/video/';
const WIX_AUDIO_URL = 'https://static.wixstatic.com/mp3/';
const WIX_DOCUMENT_URL = 'https://d945e594-8657-47e2-9cd9-e9033c3d8da0.usrfiles.com/ugd/';
export function getScaledToFillImageUrl(wixMediaIdentifier, targetWidth, targetHeight, options) {
    const img = getImageUrl(wixMediaIdentifier);
    return sdk.getScaleToFillImageURL(img.id, img.height, img.width, targetWidth, targetHeight, options);
}
export function getScaledToFitImageUrl(wixMediaIdentifier, targetWidth, targetHeight, options) {
    const img = getImageUrl(wixMediaIdentifier);
    return sdk.getScaleToFitImageURL(img.id, img.height, img.width, targetWidth, targetHeight, options);
}
export function getCroppedImageUrl(wixMediaIdentifier, cropX, cropY, cropWidth, cropHeight, targetWidth, targetHeight, options) {
    const img = getImageUrl(wixMediaIdentifier);
    return sdk.getCropImageURL(img.id, img.height, img.width, cropX, cropY, cropWidth, cropHeight, targetWidth, targetHeight, options);
}
export function getImageUrl(val) {
    let id, filenameOrAltText;
    let height, width;
    if (val.startsWith(WIX_IMAGE_URL)) {
        id = val.split(WIX_IMAGE_URL).pop().split('/')[0];
        width = val.split('/w_').pop().split(',')[0];
        height = val.split(',h_').pop().split(',')[0];
    }
    else {
        const alignedImage = alignIfLegacy(val, WIX_IMAGE);
        const { hash, pathname } = new URL(alignedImage);
        const params = new URLSearchParams(hash.replace('#', ''));
        height = params.get('originHeight');
        width = params.get('originWidth');
        [id, filenameOrAltText] = pathname
            .replace(`${WIX_IMAGE}://v1/`, '')
            .split('/');
    }
    // @ts-expect-error
    const decodedFilenameOrAltText = decodeText(filenameOrAltText);
    const res = {
        id,
        url: `${WIX_IMAGE_URL}${id}`,
        height: Number(height),
        width: Number(width),
    };
    if (!decodedFilenameOrAltText) {
        return res;
    }
    return {
        ...res,
        altText: decodedFilenameOrAltText,
        filename: decodedFilenameOrAltText,
    };
}
export function getVideoUrl(val, resolution) {
    let id, thumbnailId, thumbnailWidth, thumbnailHeight, decodedFilename = '';
    if (val.startsWith(WIX_VIDEO_URL)) {
        id = val.split(WIX_VIDEO_URL).pop().split('/')[0];
        thumbnailId = `${id}.jpg`;
        thumbnailWidth = '50';
        thumbnailHeight = '50';
    }
    else {
        const alignedVideo = alignIfLegacy(val, WIX_VIDEO);
        const { pathname, hash } = new URL(alignedVideo);
        const hashParams = new URLSearchParams(hash.replace('#', ''));
        const [_id, fileName] = pathname
            .replace(`${WIX_VIDEO}://v1/`, '')
            .split('/');
        id = _id;
        thumbnailId = hashParams.get('posterUri') || `${id}.jpg`;
        thumbnailWidth = hashParams.get('posterWidth') || '50';
        thumbnailHeight = hashParams.get('posterHeight') || '50';
        decodedFilename = decodeText(fileName);
    }
    const res = {
        id,
        url: `${WIX_VIDEO_URL}${id}/${resolution ? `${resolution}/mp4/file.mp4` : 'file'}`,
        thumbnail: `${WIX_PROTOCOL}${WIX_IMAGE}://v1/${thumbnailId}#originWidth=${thumbnailWidth}&originHeight=${thumbnailHeight}`,
    };
    if (!decodedFilename) {
        return res;
    }
    return {
        ...res,
        filename: decodedFilename,
    };
}
export function getAudioUrl(val) {
    const alignedAudio = alignIfLegacy(val, WIX_AUDIO);
    const { pathname, hash } = new URL(alignedAudio);
    const [id, filename] = pathname.replace(`${WIX_AUDIO}://v1/`, '').split('/');
    const decodedFilename = decodeText(filename);
    const hashParams = new URLSearchParams(hash.replace('#', ''));
    const res = {
        id,
        duration: Number(hashParams.get('duration') || ''),
        url: `${WIX_AUDIO_URL}${id}`,
    };
    if (!decodedFilename) {
        return res;
    }
    return {
        ...res,
        filename: decodedFilename,
    };
}
export function getDocumentUrl(val) {
    const valWithoutUGD = val.replace('v1/ugd', 'v1');
    const alignedDocument = alignIfLegacy(valWithoutUGD, WIX_DOCUMENT);
    const { pathname } = new URL(alignedDocument);
    const [id, filename] = pathname
        .replace(`${WIX_DOCUMENT}://v1/`, '')
        .split('/');
    const decodedFilename = decodeText(filename);
    const res = {
        id,
        url: `${WIX_DOCUMENT_URL}${id}`,
    };
    if (!decodedFilename) {
        return res;
    }
    return {
        ...res,
        filename: decodedFilename,
    };
}
export function decodeText(s) {
    if (!s) {
        return s;
    }
    return decodeURIComponent(s);
}
function alignIfLegacy(url, type) {
    const { protocol } = new URL(url);
    return protocol === `${type}:` ? `${WIX_PROTOCOL}${url}` : url;
}
export var VideoResolution;
(function (VideoResolution) {
    VideoResolution["MOBILE"] = "360p";
    VideoResolution["LOW"] = "480p";
    VideoResolution["MID"] = "720p";
    VideoResolution["HIGH"] = "1080p";
})(VideoResolution || (VideoResolution = {}));
